﻿﻿export interface IProductCenterChange {
    id: number;
    productCenterId: number;
    previousOwnerContactId: number;
    previousProductStatusId: number;
}
